<div class="card">
  <app-header titulo="Validação Nota Fiscal" descricao="Ativação e desativação das validações aplicadas no recebimento das notas fiscais do PIMS"></app-header>

  <p-table [value]="registros" dataKey="publicId" [loading]="loading"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
           currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <span class="ml-auto">
          <button pButton pRipple icon="pi pi-refresh" (click)="carregar()" [loading]="loading"></button>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Validação</th>
        <th>Descrição</th>
        <th>Ativo</th>
        <th>Data Atualização</th>
        <th>Atualizado Por</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-registro>
      <tr>
        <td>{{ registro.validacao }}</td>
        <td>{{ registro.descricao }}</td>
        <td>
          <p-inputSwitch [(ngModel)]="registro.ativo" (onChange)="alternarStatus(registro)"></p-inputSwitch>
        </td>
        <td>{{ registro.dataAtualizacao | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ registro.atualizadoPor }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Nenhum registro encontrado</td>
      </tr>
    </ng-template>
  </p-table>
</div>
